import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { ChangeDetectionStrategy, Component, computed, effect, input, signal, ViewEncapsulation } from '@angular/core';
import { EnpsControlComponent } from '@common/controls/enps-control/enps-control';

@Component({
    selector: 'st-assignment-type',
    templateUrl: './assignment-type.html',
    styleUrls: ['./assignment-type.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'st-assignment-type',
    },
})
export class AssignmentTypeComponent extends EnpsControlComponent<string> {
    data = input<StorytellingAssignmentRecord>();
    value = input<string>('');
    showLabel = input(false, {
        transform: coerceBooleanProperty,
    });

    mediumIcon = input(false, {
        transform: coerceBooleanProperty,
    });

    showIcon = input(true, {
        transform: coerceBooleanProperty,
    });

    internalValue = signal<string[]>([]);

    assignmentTypes = computed(() => {
        return this.globalTablesService.getListItemsForField(this.appService.PSTFieldNames.DescriptionType) || [];
    });

    selectedTypeLabel = computed(() => {
        return this.assignmentTypes().find(item => item.id === this.internalValue()?.[0])?.title;
    });

    selectedValue = computed(() => {
        return this.assignmentTypes().find(item => item.id === this.internalValue()?.[0])?.id;
    });

    isDisabled = computed(() => {
        if (this.data()?.Path?.isWasteBinPath) {
            return true;
        }
        return false;
    });

    hasValue = computed(() => {
        return !!this.internalValue();
    });

    constructor() {
        super();
        effect(
            () => {
                const val = this.value();
                this.internalValue.set([val]);
            },
            { allowSignalWrites: true }
        );
    }

    select(value: string) {
        this.changed.emit(value);
    }
}
